import firestoreServices from './firestore.service';

const notificationsHistoryFirestoreServices = firestoreServices(
  'notificationsHistory'
);

export default {
  ...notificationsHistoryFirestoreServices,
  get: (value, onResult) => {
    notificationsHistoryFirestoreServices
      .collectionRef()
      .where('usersNotRead', 'array-contains', value)
      .get()
      .then(async queryResult => {
        onResult(queryResult.docs);
      })
      .catch(error => console.error(error));
  },
  setRead: (id, value, onResult) => {
    notificationsHistoryFirestoreServices.update(id, value);
  },
  deleteNotification: (id, value, onResult) => {
    notificationsHistoryFirestoreServices.update(id, value);
  }
};
